import { render, staticRenderFns } from "./classTeacher.vue?vue&type=template&id=39f5a8fc&scoped=true"
import script from "./classTeacher.vue?vue&type=script&lang=js"
export * from "./classTeacher.vue?vue&type=script&lang=js"
import style0 from "./classTeacher.vue?vue&type=style&index=0&id=39f5a8fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f5a8fc",
  null
  
)

export default component.exports